export default {"src":"/login-app/[GIT_HASH]/_next/static/media/diamond.184e2c6c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};